import React from 'react'
import Grid from '@material-ui/core/Grid'
import Button from '@material-ui/core/Button'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'

import Input from 'components/shared/Input'

interface IProps {
  handlePasswordReset: (code: string, password: string) => void
  goBack: () => void
  error: string
}

interface IState {
  password: string
  passwordConfirm: string
  code: string
}

class PasswordResetScreen extends React.Component<IProps, IState> {
  constructor(props: any) {
    super(props)
    this.state = {
      code: '',
      password: '',
      passwordConfirm: '',
    }
  }

  _handlePasswordChange = (evt: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({
      ...this.state,
      password: evt.currentTarget.value,
    })
  }

  _handlePasswordConfirmChange = (evt: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({
      ...this.state,
      passwordConfirm: evt.currentTarget.value,
    })
  }

  _handleCodeChange = (evt: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({
      ...this.state,
      code: evt.currentTarget.value,
    })
  }

  _handlePasswordReset = async event => {
    const { code, password, passwordConfirm } = this.state
    event.preventDefault()
    if (!this._isDataValid()) return
    this.props.handlePasswordReset(code, password)
  }

  _isDataValid = () => {
    const { code, password, passwordConfirm } = this.state
    return code && password && passwordConfirm && password === passwordConfirm
  }

  render() {
    const { code, password, passwordConfirm } = this.state
    const { error, goBack } = this.props
    return (
      <form name="login" onSubmit={this._handlePasswordReset}>
        <Grid container direction="column" spacing={3} style={{ backgroundColor: '#fff' }}>
          <Box p={{ xs: 2, md: 4, lg: 6 }}>
            <Grid item>
              <Typography variant="h4" color="secondary">
                Verification code has been sent to you!
              </Typography>
            </Grid>
            <Grid item>
              <Input label="Verification Code" value={code} onChange={this._handleCodeChange} />
            </Grid>
            <Grid item>
              <Input label="New Password" type="password" value={password} onChange={this._handlePasswordChange} />
            </Grid>
            <Grid item>
              <Input
                label="Confirm Password"
                type="password"
                value={passwordConfirm}
                onChange={this._handlePasswordConfirmChange}
              />
            </Grid>
            <Grid item>
              <Box mt={{ xs: 2 }}>
                <Typography variant="h4" color="error">
                  Password must be 6 characters including 1 number.
                </Typography>
              </Box>
            </Grid>
            <Grid container justify="space-evenly">
              <Grid item xs={4}>
                <Box mt={{ xs: 2, md: 5 }}>
                  <Button fullWidth variant="contained" onClick={goBack}>
                    <Typography variant="h4" color="primary">
                      Go back
                    </Typography>
                  </Button>
                </Box>
              </Grid>
              <Grid item xs={4}>
                <Box mt={{ xs: 2, md: 5 }}>
                  <Button fullWidth variant="contained" type="submit" disabled={!this._isDataValid()}>
                    <Typography variant="h4" color="primary">
                      Reset
                    </Typography>
                  </Button>
                </Box>
              </Grid>
            </Grid>
            {error && (
              <Box mt={{ xs: 2 }}>
                <Typography variant="h4" color="error">
                  {error}
                </Typography>
              </Box>
            )}
          </Box>
        </Grid>
      </form>
    )
  }
}

export default PasswordResetScreen
